export default{
    'navBar.lang': '语言',
    'navBar.logout': '退出登录',
    'navBar.setting': '个人设置',
}